__turbopack_context__.v({
  "container": "StatsGrid-module__4v4h-G__container",
  "grid": "StatsGrid-module__4v4h-G__grid",
  "groupLeft": "StatsGrid-module__4v4h-G__groupLeft",
  "groupRight": "StatsGrid-module__4v4h-G__groupRight",
});
